import { Box, Pagination } from '@mui/material';
import { filterComputedSlides } from 'components/AITools/utilities/common';
import {
  FILTER_BUTTONS,
  SLIDES_INCREMENT,
} from 'components/pages/AppLibrary/constants';
import { useFilteredSlidesStyles } from 'components/pages/AppLibrary/styles';
import { useMemo } from 'react';
import { Spinner } from 'components/Loading/Spinner/Spinner';
import { SlidesList } from 'components/pages/AppLibrary/SlidesList';
import { useGetMlComputeOrdersQuery } from 'store/apis/walletApi';
import { useFilteredSlidesPagination } from 'components/pages/AppLibrary/hooks';

export const FilteredSlides = ({
  activeFilter,
  initialSlides = [],
  isLoading = false,
  model,
  isAppLibrary = false,
}) => {
  const { classes } = useFilteredSlidesStyles();
  const { data, isLoading: isLoadingComputeOrders } =
    useGetMlComputeOrdersQuery();

  const isDataLoading =
    activeFilter === FILTER_BUTTONS.applicable
      ? isLoading
      : isLoadingComputeOrders;

  const filteredSlides = useMemo(
    () =>
      activeFilter === FILTER_BUTTONS.applicable
        ? initialSlides
        : filterComputedSlides(data, activeFilter, model),
    [model, activeFilter, data, initialSlides],
  );

  const {
    currentPage,
    totalPages,
    showPagination,
    currentSlides,
    onChangePage,
  } = useFilteredSlidesPagination({
    slides: filteredSlides,
    countPerPage: SLIDES_INCREMENT,
  });

  return (
    <Box>
      {!isLoading && !isLoadingComputeOrders && !filteredSlides?.length && (
        <Box className={classes.noSlides}>No slides</Box>
      )}
      {isDataLoading ? (
        <Box className={classes.spinner}>
          <Spinner />
        </Box>
      ) : (
        <>
          {showPagination && (
            <Pagination
              page={currentPage}
              className={classes.pagination}
              count={totalPages}
              variant="outlined"
              shape="rounded"
              onChange={onChangePage}
            />
          )}
          <SlidesList
            classes={classes}
            resultsCount={filteredSlides?.length}
            slides={currentSlides}
            isAppLibrary={isAppLibrary}
          />
          {showPagination && (
            <Pagination
              page={currentPage}
              className={classes.pagination}
              count={totalPages}
              variant="outlined"
              shape="rounded"
              onChange={onChangePage}
            />
          )}
        </>
      )}
    </Box>
  );
};
